import React from 'react';

export const AskRovoIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.49074 0.135176C5.80615 -0.0450587 6.19336 -0.0450584 6.50877 0.135176L10.869 2.62676C11.1887 2.80943 11.386 3.14937 11.386 3.51754V8.48246C11.386 8.85063 11.1887 9.19057 10.869 9.37324L6.50877 11.8648C6.19336 12.0451 5.80615 12.0451 5.49074 11.8648L1.13046 9.37324C0.810801 9.19057 0.613525 8.85063 0.613525 8.48246V3.51754C0.613525 3.14937 0.810801 2.80943 1.13046 2.62676L5.49074 0.135176Z"
			fill="#BF63F3"
		/>
		<mask
			id="mask0_6986_15961"
			mask-type="alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="12"
			height="12"
		>
			<path
				d="M5.49147 0.135176C5.80688 -0.0450587 6.19409 -0.0450584 6.5095 0.135176L10.8698 2.62676C11.1894 2.80943 11.3867 3.14937 11.3867 3.51754V8.48246C11.3867 8.85063 11.1894 9.19057 10.8698 9.37324L6.5095 11.8648C6.19409 12.0451 5.80688 12.0451 5.49147 11.8648L1.13119 9.37324C0.811533 9.19057 0.614258 8.85063 0.614258 8.48246V3.51754C0.614258 3.14937 0.811533 2.80943 1.13119 2.62676L5.49147 0.135176Z"
				fill="#BF63F3"
			/>
		</mask>
		<g mask="url(#mask0_6986_15961)">
			<path
				d="M1.16263 17.7949C1.88779 16.4071 2.94666 15.3192 4.34106 14.5785C5.73547 13.8378 7.35475 13.5206 8.99416 13.7092L0.174522 -2.55519C-1.28798 -2.29055 -2.70998 -1.80225 -4.07857 -1.07526C-5.44715 -0.348264 -6.62399 0.522036 -7.64596 1.5465L1.16631 17.7973L1.16263 17.7949Z"
				fill="#82B536"
			/>
			<path
				d="M6.24771 7.95377C3.81432 8.96062 1.95589 10.6236 1.8802 12.9253C1.8802 12.9253 1.8815 12.9371 1.88027 12.9428C1.87529 13.1139 1.87847 13.2868 1.89421 13.4633C1.89484 13.4648 1.89547 13.4663 1.8961 13.4678C1.91091 13.6465 1.93669 13.8294 1.97284 14.0151C1.9821 14.0588 1.99576 14.1041 2.00502 14.1478C2.0382 14.296 2.07137 14.4442 2.1193 14.5968C2.18279 14.7994 2.25662 15.0047 2.34521 15.2144C2.5091 15.6024 2.70136 15.9488 2.90883 16.2571C3.18503 16.6673 3.48793 17.0101 3.78966 17.2936C3.86549 17.3643 3.94004 17.432 4.01647 17.4954C4.37163 17.7357 4.89043 18.0543 5.75971 18.4584C6.32751 18.7233 7.04875 19.025 7.97233 19.3662C8.71091 18.2422 10.0624 17.368 11.3272 16.3888C12.3258 15.6149 13.2677 14.7764 13.8045 13.6971C14.2969 12.7085 14.3097 11.4765 13.7699 10.1986C12.4189 7.00012 9.42849 6.63591 6.25021 7.95097L6.24771 7.95377Z"
				fill="#FCA700"
			/>
			<path
				d="M11.6629 -7.61136L-2.8151 -5.02797C-2.8151 -5.02797 -1.32429 1.52224 -4.56029 7.48526C-4.11721 7.5189 -3.66895 7.5392 -3.21571 7.53288C5.11974 7.41664 11.7803 0.635945 11.6629 -7.61401L11.6629 -7.61136Z"
				fill="#1868DB"
			/>
		</g>
		<path
			d="M5.6719 2.71364C5.90662 2.58408 6.19311 2.58646 6.42592 2.72078L8.69095 4.02848C8.928 4.16524 9.07473 4.41898 9.07473 4.69232V7.30776C9.07473 7.58218 8.92889 7.83479 8.69114 7.97148L6.9885 8.95449C6.99223 8.94401 6.99578 8.93347 6.99917 8.92286C7.03077 8.82487 7.04752 8.72132 7.04752 8.61548V6.00004C7.04752 5.64073 6.85641 5.3094 6.5447 5.13016L5.2755 4.39771V3.3846C5.2755 3.30477 5.28784 3.22678 5.31119 3.15296C5.36861 2.97429 5.49073 2.81962 5.6578 2.72306L5.6583 2.72277C5.66309 2.72001 5.66765 2.71694 5.6719 2.71364Z"
			fill="white"
		/>
		<path
			d="M5.09551 3.04811L3.39287 4.03112C3.15512 4.1678 3.00928 4.42042 3.00928 4.69484V7.31028C3.00928 7.58362 3.15598 7.83734 3.39303 7.9741L5.65808 9.28182C5.8909 9.41612 6.1774 9.41851 6.41211 9.28896C6.41636 9.28566 6.42088 9.28261 6.42567 9.27985C6.59292 9.18336 6.71523 9.02863 6.77274 8.84989C6.79614 8.77599 6.80851 8.69792 6.80851 8.618V7.60489L5.53938 6.87249C5.22773 6.69323 5.03648 6.36183 5.03648 6.00256V3.38712C5.03648 3.28142 5.05319 3.17802 5.08471 3.08015C5.08813 3.0694 5.09173 3.05872 5.09551 3.04811Z"
			fill="white"
		/>
	</svg>
);
